/**
 * SEARCH mobile — poignée de révélation de la recherche globale.
 *
 * Sur mobile, il n'y a PLUS de champ de recherche persistant : un petit chevron
 * discret et centré dans la bande haute (header) sert de signifiant. Deux voies
 * d'accès (le geste n'est jamais la seule — a11y) :
 *   • tap sur la poignée → ouvre le panneau de recherche ;
 *   • swipe vers le bas depuis le header → même chose (câblé dans `AppHeader`
 *     via `useSwipeToReveal`).
 *
 * Le chevron oscille en permanence (translateY discret) pour « enseigner » le
 * geste swipe. L'oscillation est coupée sous `prefers-reduced-motion`.
 * Masqué en desktop (`md:hidden`) — le desktop garde son champ fusionné.
 */

import { ChevronDown } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { useGlobalSearch } from '@/hooks/useGlobalSearch'

export function SearchRevealHandle() {
    const { t } = useTranslation()
    const { open } = useGlobalSearch()

    return (
        <button
            type="button"
            onClick={open}
            aria-label={t('globalSearch.open_aria')}
            className="flex h-11 w-24 shrink-0 items-center justify-center rounded-full text-muted-foreground/60 transition-colors hover:text-foreground active:scale-95 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary md:hidden"
        >
            <ChevronDown
                className="h-5 w-5 motion-safe:animate-[search-reveal-bounce_1.8s_ease-in-out_infinite] motion-reduce:animate-none"
                aria-hidden="true"
            />
        </button>
    )
}
